import styled from "styled-components";

const Heading = styled.h1`
  font-size: 4.5rem;
  font-weight: 500;
  font-family: 'Marck Script', Montserrat;
  color: ${({ theme }) => theme.palette.common.black};
`;

export default Heading;